const featuredByOptions = [
  {
    label: 'Award Winners',
    value: 'showAwards'
  },
  {
    label: 'Bestsellers',
    value: 'showBestsellers'
  },
  {
    label: 'Coming Soon',
    value: 'showComingSoon'
  },
  {
    label: 'New Releases',
    value: 'showNewReleases'
  }
];

export { featuredByOptions };
